import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GoogleLogin as OAuthLogin } from '@react-oauth/google';
import './GoogleLogin.css';
import { analytics, logEvent } from "./firebase"; // Import Firebase Analytics

const GoogleLogin = ({ onLoginSuccess, onLoginFailure }) => {
  const navigate = useNavigate();  // Use navigate here to redirect after login/logout

  const handleGoogleLogin = async (response) => {
    // Perform Google Login Actions
    console.log("Google Login Success:", response);
    
    // Log the Google SSO login event in Firebase Analytics
    logEvent(analytics, "login", { method: "Google SSO" });

    // Call onLoginSuccess callback
    onLoginSuccess(response);
  };

  const handleLogout = () => {
    logEvent(analytics, "logout", { method: "Google SSO" });  // Log logout event
    localStorage.removeItem('isLoggedIn');
    localStorage.removeItem('isAuthorized');
    navigate('/login');  
};


  return (
    <div className="google-login-container">
      <div className="login-box">
        <div className="loginheader">
          <h1>Welcome to Haqdarshak</h1>
          <p className="loginsub-header">Every Citizen Matters.</p>
        </div>
        <div className="login-section">
          <p>Please Sign In to View Achievement Report</p>
          <OAuthLogin
            onSuccess={handleGoogleLogin}  // Call the updated function
            onError={onLoginFailure}
            className="login-button"
          />
        </div>
      </div>
    </div>
  );
};

export default GoogleLogin;
